import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { PropType } from "vue";
import BaseInput from "@/ui-library/base-input/base-input.vue";
import PasswordInput from "./password-input.vue";
import { computed } from "vue";
import BaseTypography from "@/ui-library/base-typography/base-typography.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'email-and-password-inputs',
  props: {
  tabIndexes: {
    type: Array as PropType<Array<number | undefined>>,
    default: () => [undefined, undefined],
  },
  email: {
    type: String,
    default: "",
  },
  password: {
    type: String,
    default: "",
  },
},
  emits: {
  signIntoApp: null,
  "update:email": (email: unknown) => typeof email === "string",
  "update:password": (password: unknown) => typeof password === "string",
},
  setup(__props, { emit: emits }) {

const props = __props





const password = computed({
  get: () => props.password,
  set: (password: string) => {
    emits("update:password", password);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseTypography, null, {
    default: _withCtx(() => [
      _createVNode(BaseInput, {
        tabindex: __props.tabIndexes[0],
        name: "email",
        type: "email",
        modelValue: __props.email,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:email', $event.target.value))),
        label: "Email",
        autocomplete: "on",
        textAlign: "center"
      }, null, 8, ["tabindex", "modelValue"]),
      _hoisted_1,
      _createVNode(PasswordInput, {
        modelValue: _unref(password),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(password) ? (password).value = $event : null)),
        tabIndex: __props.tabIndexes[1],
        label: "password",
        textAlign: "center"
      }, null, 8, ["modelValue", "tabIndex"])
    ]),
    _: 1
  }))
}
}

})